import type { AskUserQuestionOneOfTwo } from "@/api/generated/models";
import {
  type ChoiceValue,
  SingleSelectInline,
} from "@/conversation/AskUserQuestionsPanel/OptionParts";

export default function OneOfTwoQuestion({
  question,
  value,
  onChange,
  onSubmit,
  onSkip,
  isLast,
}: {
  question: AskUserQuestionOneOfTwo;
  value: ChoiceValue;
  onChange: (value: ChoiceValue) => void;
  onSubmit: () => void;
  onSkip: () => void;
  isLast: boolean;
}) {
  return (
    <SingleSelectInline
      options={question.options}
      value={value}
      onChange={onChange}
      onSubmit={onSubmit}
      onSkip={onSkip}
      isLast={isLast}
    />
  );
}
